import { TypeOf, z } from "zod";
import {
  isValidCnpj,
  isValidCpf,
  maskRemove,
} from "../../services/UtilsService";

const legalPersonSchema = z
  .object({
    name: z.string().nonempty("Nome é obrigatório"),
    documentNumber: z
      .string()
      .nonempty("CNPJ é obrigatório")
      .refine((cnpj) => isValidCnpj(maskRemove(cnpj)), "CNPJ inválido"),
    responsibleName: z.string().nonempty("Nome do responsável é obrigatório"),
    responsibleCpf: z
      .string()
      .nonempty("CPF do responsável é obrigatório")
      .refine((cpf) => isValidCpf(maskRemove(cpf)), "CPF inválido"),
    mobilePhone: z
      .string()
      .min(15, "Celular inválido")
      .nonempty("Celular é obrigatório")
      .transform((mobilePhone) => "55" + maskRemove(mobilePhone)),
    email: z.string().nonempty("Email é obrigatório").email("Email inválido"),
    password: z.string().nonempty("Senha é obrigatória"),
    passwordConfirmation: z
      .string()
      .nonempty("Confirmação de senha é obrigatória"),
    legalRepresentativeCheck: z.boolean(),
    agreedLegalTerms: z.literal(true, {
      errorMap: () => ({
        message:
          "Você deve concordar com os termos de uso e política de privacidade",
      }),
    }),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "As senhas devem ser iguais",
    path: ["passwordConfirmation"],
  });

type LegalPersonInput = TypeOf<typeof legalPersonSchema>;

export type { LegalPersonInput };
export { legalPersonSchema };
